import React, { useEffect, useState } from "react";

export default function BackToTopButton({
  targetElement = null,
  hideWhenModalOpen = false,
  isModal = false,
  className = "",
  style,
}) {
  const [isVisible, setIsVisible] = useState(false);
  const [shouldHide, setShouldHide] = useState(false);

  useEffect(() => {
    // For modal mode wait until a concrete scroll container is provided
    if (isModal && !targetElement) {
      setIsVisible(false);
      return undefined;
    }

    const target = targetElement || window;

    const handleScroll = () => {
      const scrollTop = targetElement
        ? targetElement.scrollTop
        : window.pageYOffset || document.documentElement.scrollTop;

      setIsVisible(scrollTop > 300);
    };

    target.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => {
      target.removeEventListener("scroll", handleScroll);
    };
  }, [targetElement, isModal]);

  useEffect(() => {
    if (hideWhenModalOpen) {
      setShouldHide(true);
    } else {
      const timeout = setTimeout(() => {
        setShouldHide(false);
      }, 100);
      return () => clearTimeout(timeout);
    }
  }, [hideWhenModalOpen]);

  const scrollToTop = () => {
    if (targetElement) {
      targetElement.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    scrollToTop();
  };

  const handleTouch = (e) => {
    e.preventDefault();
    e.stopPropagation();
    scrollToTop();
  };

  const shouldShow = isVisible && !shouldHide;
  const buttonClass = isModal ? "back-to-top-modal" : "back-to-top";

  return (
    <button
      className={`${buttonClass} ${className} ${shouldShow ? "visible" : ""}`.trim()}
      onClick={handleClick}
      onTouchEnd={handleTouch}
      aria-label="Back to top"
      title="Back to top"
      style={style}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth="2"
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
      </svg>
    </button>
  );
}
